module.exports = __webpack_public_path__ + "img/physics.3d1edfd3.svg";